import { render } from "./SupportTicketsTable.vue?vue&type=template&id=dfcfd9b8"
import script from "./SupportTicketsTable.vue?vue&type=script&lang=js"
export * from "./SupportTicketsTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__